import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DesktopDrawerService {
  private readonly isOpenSubject = new BehaviorSubject<boolean>(false);
  private readonly contentSubject = new BehaviorSubject<TemplateRef<any> | null>(null);

  isOpen$: Observable<boolean> = this.isOpenSubject.asObservable();
  content$: Observable<TemplateRef<any> | null> = this.contentSubject.asObservable();

  openDrawer(content: TemplateRef<any>): void {
    this.contentSubject.next(content);
    this.isOpenSubject.next(true);
  }

  closeDrawer(): void {
    this.isOpenSubject.next(false);
  }
}
